import { Link, useNavigate} from "react-router-dom";
import { useState } from "react";
import loginIcon from "../../imagenesLogin/login-icon.svg"
import vdpIcon from "../../imagenesLogin/VdpLogo.png"
import passwordIcon from "../../imagenesLogin/password-icon.svg"
import usernameIcon from "../../imagenesLogin/username-icon.svg"
import Alerta from "../Alerta";
import axios from "axios";
import API from '../utils/api';
import useAuth from "../hooks/useAuth";


const Login = () => {
  const [mailLogin, setMailLogin] = useState("")
  const [passwordLogin, setPasswordLogin] = useState("")
  const [alerta, setAlerta] = useState({})
  var url = API.urlAPI
  const urlLogin = url + "usuarios/login"

  const { setAuth } = useAuth();

  const navigate = useNavigate()

  const handleSubmit= async e=>{
    if([mailLogin,passwordLogin].includes('')){
         setAlerta({
                msg: 'Todos los campos son obligatorios',
                error: true
            });
        return
    }
    try {
      const { data } = await axios.post(urlLogin, { "mail":mailLogin, "password":passwordLogin})
      setAlerta({})
      localStorage.setItem('token', data.token)
      localStorage.setItem('perfil', data.perfil)
      setAuth(data)
      navigate('/prestamos')
      console.log(data)
  } catch (error) {
    console.log(error.response.data.msg)
      setAlerta({
          msg: error.response.data.msg,
          error: true
      })
  }
  }

  const { msg } = alerta
  return (
    <div className=" d-flex justify-content-center align-items-center mt-5">
       
    <div
      
      className="bg-white p-5 rounded-5 text-secondary shadow "
      style={{width: "25rem"}}
    >
      
      <div className="d-flex justify-content-center">
        <img
          src={vdpIcon}
          alt="login-icon"
          style={{height: "6rem"}}
        />
      </div>
      
      <div className="text-center fs-1 fw-bold">Login</div>
        {msg && 
            <Alerta alerta={alerta}></Alerta>
        }
      <div className="input-group mt-4">
        
        <div className="input-group-text " style={{ background: "#005187" }}>
          <img
            src={usernameIcon}
            alt="username-icon"
            style={{height: "1rem"}}
          />
        </div>
        <input
          className="form-control bg-light"
          type="email"
          placeholder="Mail"
          value={mailLogin}
          onChange={e=>setMailLogin(e.target.value)}
        />
      </div>
      <div className="input-group mt-1">
        <div className="input-group-text" style={{ background: "#005187" }}>
          <img
            src={passwordIcon}
            alt="password-icon"
            style={{height: "1rem"}}
            
          />
        </div>
        <input
          className="form-control bg-light"
          type="password"
          placeholder="contraseña"
          value={passwordLogin}
          onChange={e=>setPasswordLogin(e.target.value)}
         
        />
      </div>
      
      <div className="d-flex justify-content-around mt-1">
        <div className="d-flex align-items-center gap-1">
          <input className="form-check-input" type="checkbox" />
          <div className="pt-1 ont-09" >Recordar</div>
        </div>
        <div className="pt-1">
          <Link
            to= "/olvide-password"
            className="text-decoration-none  fw-semibold fst-italic" style={{ color: "#005187" }}
            >Olvido su contraseña?
            </Link>
        </div>
      </div>
      <div className="btn btn-warning text-white w-100 mt-4 fw-semibold shadow-sm" style={{ background: "#005187", color: "white" ,padding: "0.4rem", marginRight: "10px", border:"black"}}onClick={handleSubmit}>
        Login
      </div>
      <div className="d-flex gap-1 justify-content-center mt-1">
      
     
      </div>
    </div>
    </div>
  )
}

export default Login